<template>
  <li>
    <slot />
  </li>
</template>

<style lang="postcss" scoped>
li {
  position: relative;
  margin-bottom: .75rem;
  margin-top: .75rem;
  padding-left: .5rem;
}

ul>li::marker {
  color: var(--color-gray-300);
}

ol>li::marker {
  color: var(--color-gray-400);
}

:deep(.nuxt-content-highlight) {
  margin: 0;
}
</style>
